<template>
  <v-content>
      <div class="flexiapp-bg-header-container" style="z-index: 0;"></div>
      <div class="flexiapp-bg"></div>

    <v-row v-if="!isLoading && !!errorMessage" cols="12" justify="center">
      <v-alert type="info" class="mx-auto col-10" justify="center">{{
        errorMessage
      }}</v-alert>
    </v-row>

    <!-- Cabecera Workorder -->
    <v-card ref="orderHeader"> <!-- class="mx-auto elevation-2 mb-3 card-flexiapps-home card-flexiapp-guide-view" -->
        <v-card-text>
            <div class="mb-1 flexiapp-carrier-text">{{workorder.id}}-{{workorder.carrier}}</div>
            <p class="display-1 text--primary title-flexiapps-home mb-1">{{workorder.bookingId}}</p>
            <div class="mb-1 flexiapp-count-text"
            v-bind:style="{ color: compareLinesStatus()}">{{calculateLinesStatusSum()}}/{{calculateLinesStatusSize()}}</div>
            <v-icon
                medium
                color="#EF8F21"
                class="ml-2 flexiapp-noimage-icon" 
                v-if="isUploadPending()"
                >mdi-camera-off
            </v-icon>
            <div class="flexiapp-date-reported-container">
                <div class="mb-2">
                    <span>{{$t('home.maxDateOut')}}</span> 
                    <span>{{getFormattedDate(workorder.maxDateOut)}}</span>
                </div>
                <div class="mb-2">
                   <span>{{$t('home.assemblyDate')}}</span>
                   <span>{{getFormattedDate(workorder.assemblyDate)}}</span>
                </div>
            </div>
            <!-- Comments --> 
            <v-divider class="pa-1" v-if="!isEmptyField(workorder.comment)"></v-divider>
            <div class="flexiapp-comments-container" v-if="!isEmptyField(workorder.comment)">
                <p class="pa-2 pt-1 mb-0 flexiapp-comment-text">{{workorder.comment}}</p>
            </div>
            
        </v-card-text>
    </v-card>

    <!-- Order List -->  
    <v-card v-if="!isLoading && !errorMessage"
        color="white"
        class="mx-auto pa-4 card-flexiapps-home" style="margin-top: 20px;"
        tile>
        <!-- Title -->
        <!-- Content -->
        <v-card-text class="flexiapp-order-card-content" style="padding: 0;" @click="selectLine(item)" v-for="item in lines" :key="item.id">
            <!-- Loader -->
            <v-row v-if="isLoading" cols="12" justify="center">
                <v-col class="mx-auto" cols="12">
                    <v-skeleton-loader type="table-tbody" class="mx-auto" max-width="90%" />
                </v-col>
            </v-row>


            <!-- Left Side -->
            <div class="flexiapp-card-flex-content">
                <div class="flexiapp-type-container">{{item.containerType}}</div>
                <div class="flexiapp-number-container">{{item.containerNumber}}
                    <v-panel  v-if="isEmptyField(item.containerNumber)"> 
                      <span style="font-size: 0.875rem !important;">- -</span>
                    </v-panel>
                    <!--<v-icon
                    medium
                    color="orange"
                    class="mr-2" 
                    v-if="isEmptyField(item.containerNumber)"
                    >mdi-alert</v-icon>-->
                    <!--<v-icon small color="primary" class="ml-2"
                    @click="editLine(item, $event)">mdi-pencil</v-icon>-->
                </div>
                </div>

                <div class="flexiapp-card-flex-content">
                    <p color="primary" style="margin-bottom: 5px;">
                        {{item.flexiType}}
                    </p>
                    <div>{{item.flexiNumber}}
                       <v-panel v-if="isEmptyField(item.flexiNumber)">  
                          <span style="color: #000000 !important;">- -</span>
                       </v-panel>
                        <!--<v-icon
                        medium
                        color="orange"
                        class="mr-2" 
                        v-if="isEmptyField(item.flexiNumber)"
                        >mdi-alert</v-icon>-->
                        <!--<v-icon small color="primary" class="ml-2"
                        @click="editLine(item, $event)">mdi-pencil</v-icon>-->
                    </div>
                </div>

                <!-- Chip de montaje de barras -->
                <v-row
                  justify="center"
                  align="center"
                 >
                   <v-chip
                     small
                     label
                     outlined
                     class="mb-2 ml-1"
                     v-if="item.bars"
                   >
                    {{$t("order.bars.assemble")}}
                  </v-chip>
                </v-row>

                <!-- Comments --> 
                <div class="flexiapp-comments-container" v-if="!isEmptyField(item.comment)">
                   <p class="pa-2 pt-1 flexiapp-comment-list-text">{{item.comment}}</p>
                </div>

                <!-- Bar Progress -->
                <div class="mb-2">
                    <v-progress-linear style="border-radius: 25px;"
                    :value="calculateBar(item.status)"
                    :color="calculateBarColor(item.status)"
                    height="15"
                    ></v-progress-linear>
                </div> 
                <!-- Installer Comments --> 
                <div class="flexiapp-comments-container" v-if="!isEmptyField(item.depotComment)">
                   <span class="pa-2 pb-0 mb-0 flexiapp-comment-text" style="font-weight: 500; color: rgba(0, 86, 183, 0.7);">{{$t("order.comments.employee")}}:</span>
                   <p class="pa-2 pt-0 mb-0 flexiapp-installer-comment-text">{{item.depotComment}}</p>
                </div>           
        </v-card-text>
      </v-card>

<!--    <EditDialog
      ref="confirmEditLine"
      v-bind:title="$t('common.editDialogTitle')"
      v-bind:message="$t('line.edit.description')"
      v-bind:titleOk="$t('common.OK')"
      v-bind:titleCancel="$t('common.close')"
      v-on:confirmed="doEditLine($event)"
    />-->

      <v-snackbar
        style="z-index:100002;"
        v-model="putError"
        :top="true"
        class="fixNotchMarginTop"
        :timeout="2000"
        color="error"
      >
        {{putErrorMessage}}
        <template v-slot:action="{ attrs }">
          <v-btn color="black" text v-bind="attrs" @click="putError = null" >{{$t('HISTORY_CLOSE')}}</v-btn>
        </template>
      </v-snackbar>
  </v-content>
</template>


<script>
// eslint-disable-next-line no-unused-vars
import api from "../../../api/flexiapp";
import BaseModule from "../../common/BaseModule"; 

export default {
  name: "OrderMain",
  mixins: [BaseModule],
  components: {}, 
  props: ['id','carrier','bookingId','maxDateOut', 'assemblyDate'],
  data() {
    return {
      isLoading: false,
      putError:false,
      putErrorMessage: null,
      errorMessage: null,
      workorder : {},
      lines: []
    };
  },
  computed: {
      statusEvent() { 
        return this.$store.state.flexiapp.workorderEvent;
      },
    },
  methods: {
      selectLine: function (line) {
          this.$router.push({ name: 'guide' , params: {id: this.$router.currentRoute.params.id, workorderId: this.$router.currentRoute.params.id, lineId: line.id, 
          status:line.status, flexiType:line.flexiType,flexiNumber:line.flexiNumber,containerType:line.containerType
          ,containerNumber:line.containerNumber, bars: line.bars, comment: line.comment, depotComment: line.depotComment } });
      },
      listarItems: function () {
      this.errorMessage= null;
      this.workorder = {};
      this.lines = [];
      this.isLoading = true;

      api.getWorkOrder(
        this.$router.currentRoute.params.id,
        (data) => {
          this.isLoading = false;
          this.workorder = data;
          this.$store.commit('flexiapp/setNavTitle', this.$t('line.header'));
          this.lines = data.workorderLines;
        },
        (error) => {
          this.isLoading = false;
          this.$log.error(error); 
          this.errorMessage=error;
        }
      );
      },
    isUploadPending(){
        return this.workorder.status==4;
    },
    calculateBar(status){
        var result = 0;
        if(status==2 || status==4){
            result = 50;
        }else if(status==3 || status==5 || status==6){
            result = 100;
        }
        return result;
    },
    calculateBarColor(status){
        var result = "amber";
        if(status==5 || status==6){
            result = "green";
        }
        return result;
    },
    isEmptyField(field){
        return field== null  ||  field.length == 0; 
    }, 
    getFormattedDate(date){
        return date ? this.formatLocalDateTime(new Date(date)) : '';
    },
    calculateWOstatus(){
      this.errorMessage= null;
      this.workorder = {};
      this.lines = [];

      api.getWorkOrder(
        this.$router.currentRoute.params.id,
        (data) => {
          this.workorder = data;
          this.$store.commit('flexiapp/setNavTitle', this.$t('line.header'));
          this.lines = data.workorderLines;
          this.doCalculateWOstatus();
        },
        (error) => {
          this.$log.error(error); 
          this.errorMessage=error;
        }
      );
    },
    doCalculateWOstatus(){
        //Get lowest status. The lowest line's status defines the workorder status
        var lowestStatus = null;
        var anyStatusHigherThan1 = false;
        if(this.lines != null && this.lines.length>0){
            lowestStatus = this.lines[0].status;
            for(var i in this.lines){
                if(this.lines[i].status>1){
                    anyStatusHigherThan1=true;
                }
                if(this.lines[i].status<lowestStatus){
                    lowestStatus=this.lines[i].status;
                }
            }
        }
        if(lowestStatus != null){
            if(lowestStatus==1 && anyStatusHigherThan1){
                lowestStatus=2;
            }else if(lowestStatus!=1 && !anyStatusHigherThan1){
                lowestStatus=1;
            }
            
            if(lowestStatus!=this.workorder.status){
                this.updateWorkorderStatus(lowestStatus);
            }
        }
    },
    updateWorkorderStatus(status){
        this.apiLoading = true; 

        var data={
            "status": status
        }

        api.putWorkOrder(
            this.$router.currentRoute.params.id,
            data,
            () => {
                this.isLoading=false;
                //this.$emit("wo-changed");
            },
            (error) => {
                this.isLoading=false;
                this.$log.error(error); 
                this.putErrorMessage=error.response.data ? error.response.data : error ;
                this.putError=true;
        });
    },
    calculateLinesStatusSum(){
         var sum = 0;
        for (var i in this.lines){
            if(this.lines[i].status == 5 || this.lines[i].status == 6){
               sum = sum+1;
            }
        }
        return sum;
      },
      calculateLinesStatusSize(){
            return this.lines ? this.lines.length : 0;
      },
    compareLinesStatus(){
          var sum = this.calculateLinesStatusSum()
          return this.calculateLinesStatusSize() == sum && sum >0 ? "green" : "#DA291B";
      },
      processBackButton(){
            window.$vue.$off('ne_backbutton');
            this.$router.push({ name: 'home'})
        }
   },
  watch: {
    statusEvent(to, from) { 
        this.$log.info('status changed:'+from +"->" + to);
        this.calculateWOstatus();
      },
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
        if(to.name == 'order')
            this.listarItems();
    },
  },
  beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.listarItems();
         window.$vue.$off('ne_backbutton');
         window.$vue.$on('ne_backbutton', vm.processBackButton);
      })
    }
};
</script>
